/* global mixpanel */
import formatDate from 'mixpanel/formatDate'

export function reportsInvoiceStart ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Invoice Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportsInvoiceChangeFilter ({outletIds, startDate, endDate, statuses}) {
  if (!statuses) {
    statuses = []
  }
  mixpanel.track('Report Invoices Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Filter Status Cancelled is Selected': statuses.includes('cancelled'),
    'Current Filter Status Unpaid is Selected': statuses.includes('unpaid'),
    'Current Filter Status Overdue is Selected': statuses.includes('overdue'),
    'Current Filter Status Paid is Selected': statuses.includes('paid'),
    'Current Filter Status Partially Paid is Selected': statuses.includes('partially_paid')
  })
}

export function reportsInvoicesSelect ({invoice}) {
  mixpanel.track('Report Invoice Select', {
    'Invoice Number': invoice.invoice_no,
    'Invoice Date Created': formatDate(invoice.created_at),
    'Invoice Status': invoice.invoice_status,
    'Invoice Total': invoice.total_collected,
    'Invoice Amount Due': invoice.total_amount_due,
    'Invoice Due Date': formatDate(invoice.invoice_due_date)
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/reports/invoices.js